module.exports = __webpack_public_path__ + "049ca055d71baf74d2b9a2a5373c1d01.svg";